
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace('')
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46slug_93q6Lnh13PhCMeta } from "/tmp/menaceking-build-1752863348/pages/[...slug].vue?macro=true";
import { default as autologinMtbTS4hZFfMeta } from "/tmp/menaceking-build-1752863348/pages/auth/autologin.vue?macro=true";
import { default as callbackH6fjGVZBd9Meta } from "/tmp/menaceking-build-1752863348/pages/auth/social/[connection]/callback.vue?macro=true";
import { default as bettingWETurrvL0RMeta } from "/tmp/menaceking-build-1752863348/pages/betting.vue?macro=true";
import { default as _91pageIdentity_93fPi0ldOCpJMeta } from "/tmp/menaceking-build-1752863348/pages/bonus/[pageIdentity].vue?macro=true";
import { default as _91categoryIdentity_93dznwx3OkZuMeta } from "/tmp/menaceking-build-1752863348/pages/categories/[categoryIdentity].vue?macro=true";
import { default as categoriesncb5LJzznDMeta } from "/tmp/menaceking-build-1752863348/pages/categories.vue?macro=true";
import { default as contactY1AC0y8uJaMeta } from "/tmp/menaceking-build-1752863348/pages/contact.vue?macro=true";
import { default as favorites_46clientRTSw6eOWKmMeta } from "/tmp/menaceking-build-1752863348/pages/favorites.client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/tmp/menaceking-build-1752863348/node_modules/nuxt/dist/components/runtime/client-component.js").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as _91id_93ARj0YFzSGRMeta } from "/tmp/menaceking-build-1752863348/pages/games/[id].vue?macro=true";
import { default as indexMplzloMWKlMeta } from "/tmp/menaceking-build-1752863348/pages/index.vue?macro=true";
import { default as loyaltyjBxxzIcpMDMeta } from "/tmp/menaceking-build-1752863348/pages/loyalty.vue?macro=true";
import { default as mainMxNwpR9TGgMeta } from "/tmp/menaceking-build-1752863348/pages/main.vue?macro=true";
import { default as bonusesmOrHGgvG7PMeta } from "/tmp/menaceking-build-1752863348/pages/profile/bonuses.vue?macro=true";
import { default as documents37dVNsL9nhMeta } from "/tmp/menaceking-build-1752863348/pages/profile/documents.vue?macro=true";
import { default as history9yJ6PhlLvAMeta } from "/tmp/menaceking-build-1752863348/pages/profile/history.vue?macro=true";
import { default as infozr3KBr3p53Meta } from "/tmp/menaceking-build-1752863348/pages/profile/info.vue?macro=true";
import { default as limitsUs2bKUBLVjMeta } from "/tmp/menaceking-build-1752863348/pages/profile/limits.vue?macro=true";
import { default as notificationsoDm1chmk59Meta } from "/tmp/menaceking-build-1752863348/pages/profile/notifications.vue?macro=true";
import { default as securityPsScuER75PMeta } from "/tmp/menaceking-build-1752863348/pages/profile/security.vue?macro=true";
import { default as verificationAhOsokNfylMeta } from "/tmp/menaceking-build-1752863348/pages/profile/verification.vue?macro=true";
import { default as wallet_45test_45v285jPKyD8PPMeta } from "/tmp/menaceking-build-1752863348/pages/profile/wallet-test-v2.vue?macro=true";
import { default as walletf1MoEQj44JMeta } from "/tmp/menaceking-build-1752863348/pages/profile/wallet.vue?macro=true";
import { default as profile_46clientczCBI4ZAreMeta } from "/tmp/menaceking-build-1752863348/pages/profile.client.vue?macro=true";
import { default as providersb3apGsIVe1Meta } from "/tmp/menaceking-build-1752863348/pages/providers.vue?macro=true";
import { default as _91pageIdentity_93ZlAC7gwabOMeta } from "/tmp/menaceking-build-1752863348/pages/questions/[pageIdentity].vue?macro=true";
import { default as questionsXxB21iBPZFMeta } from "/tmp/menaceking-build-1752863348/pages/questions.vue?macro=true";
import { default as recently_45played_46clientYjOT4DFxFcMeta } from "/tmp/menaceking-build-1752863348/pages/recently-played.client.vue?macro=true";
import { default as _91pageIdentity_93f3ZnpRaUtwMeta } from "/tmp/menaceking-build-1752863348/pages/static/[pageIdentity].vue?macro=true";
import { default as _91identity_93dOwPYhBfUNMeta } from "/tmp/menaceking-build-1752863348/pages/tournaments/[identity].vue?macro=true";
import { default as index6RXq0MrdNKMeta } from "/tmp/menaceking-build-1752863348/pages/tournaments/index.vue?macro=true";
import { default as welcome_45packagei485hBikQ9Meta } from "/tmp/menaceking-build-1752863348/pages/welcome-package.vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/tmp/menaceking-build-1752863348/pages/[...slug].vue")
  },
  {
    name: "auth-autologin",
    path: "/auth/autologin",
    component: () => import("/tmp/menaceking-build-1752863348/pages/auth/autologin.vue")
  },
  {
    name: "auth-social-connection-callback",
    path: "/auth/social/:connection()/callback",
    component: () => import("/tmp/menaceking-build-1752863348/pages/auth/social/[connection]/callback.vue")
  },
  {
    name: "betting",
    path: "/betting",
    component: () => import("/tmp/menaceking-build-1752863348/pages/betting.vue")
  },
  {
    name: "bonus-pageIdentity",
    path: "/bonus/:pageIdentity()",
    component: () => import("/tmp/menaceking-build-1752863348/pages/bonus/[pageIdentity].vue")
  },
  {
    name: "categories",
    path: "/categories",
    meta: categoriesncb5LJzznDMeta || {},
    component: () => import("/tmp/menaceking-build-1752863348/pages/categories.vue"),
    children: [
  {
    name: "categories-categoryIdentity",
    path: ":categoryIdentity()",
    component: () => import("/tmp/menaceking-build-1752863348/pages/categories/[categoryIdentity].vue")
  }
]
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/tmp/menaceking-build-1752863348/pages/contact.vue")
  },
  {
    name: "favorites",
    path: "/favorites",
    component: () => createClientPage(() => import("/tmp/menaceking-build-1752863348/pages/favorites.client.vue"))
  },
  {
    name: "games-id",
    path: "/games/:id()",
    component: () => import("/tmp/menaceking-build-1752863348/pages/games/[id].vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/tmp/menaceking-build-1752863348/pages/index.vue")
  },
  {
    name: "loyalty",
    path: "/loyalty",
    component: () => import("/tmp/menaceking-build-1752863348/pages/loyalty.vue")
  },
  {
    name: "main",
    path: "/main",
    component: () => import("/tmp/menaceking-build-1752863348/pages/main.vue")
  },
  {
    name: "profile",
    path: "/profile",
    component: () => createClientPage(() => import("/tmp/menaceking-build-1752863348/pages/profile.client.vue")),
    children: [
  {
    name: "profile-bonuses",
    path: "bonuses",
    component: () => import("/tmp/menaceking-build-1752863348/pages/profile/bonuses.vue")
  },
  {
    name: "profile-documents",
    path: "documents",
    component: () => import("/tmp/menaceking-build-1752863348/pages/profile/documents.vue")
  },
  {
    name: "profile-history",
    path: "history",
    component: () => import("/tmp/menaceking-build-1752863348/pages/profile/history.vue")
  },
  {
    name: "profile-info",
    path: "info",
    component: () => import("/tmp/menaceking-build-1752863348/pages/profile/info.vue")
  },
  {
    name: "profile-limits",
    path: "limits",
    component: () => import("/tmp/menaceking-build-1752863348/pages/profile/limits.vue")
  },
  {
    name: "profile-notifications",
    path: "notifications",
    component: () => import("/tmp/menaceking-build-1752863348/pages/profile/notifications.vue")
  },
  {
    name: "profile-security",
    path: "security",
    component: () => import("/tmp/menaceking-build-1752863348/pages/profile/security.vue")
  },
  {
    name: "profile-verification",
    path: "verification",
    component: () => import("/tmp/menaceking-build-1752863348/pages/profile/verification.vue")
  },
  {
    name: "profile-wallet-test-v2",
    path: "wallet-test-v2",
    component: () => import("/tmp/menaceking-build-1752863348/pages/profile/wallet-test-v2.vue")
  },
  {
    name: "profile-wallet",
    path: "wallet",
    component: () => import("/tmp/menaceking-build-1752863348/pages/profile/wallet.vue")
  }
]
  },
  {
    name: "providers",
    path: "/providers",
    component: () => import("/tmp/menaceking-build-1752863348/pages/providers.vue")
  },
  {
    name: "questions",
    path: "/questions",
    meta: questionsXxB21iBPZFMeta || {},
    component: () => import("/tmp/menaceking-build-1752863348/pages/questions.vue"),
    children: [
  {
    name: "questions-pageIdentity",
    path: ":pageIdentity()",
    component: () => import("/tmp/menaceking-build-1752863348/pages/questions/[pageIdentity].vue")
  }
]
  },
  {
    name: "recently-played",
    path: "/recently-played",
    component: () => createClientPage(() => import("/tmp/menaceking-build-1752863348/pages/recently-played.client.vue"))
  },
  {
    name: "static-pageIdentity",
    path: "/static/:pageIdentity()",
    component: () => import("/tmp/menaceking-build-1752863348/pages/static/[pageIdentity].vue")
  },
  {
    name: "tournaments-identity",
    path: "/tournaments/:identity()",
    component: () => import("/tmp/menaceking-build-1752863348/pages/tournaments/[identity].vue")
  },
  {
    name: "tournaments",
    path: "/tournaments",
    component: () => import("/tmp/menaceking-build-1752863348/pages/tournaments/index.vue")
  },
  {
    name: "welcome-package",
    path: "/welcome-package",
    component: () => import("/tmp/menaceking-build-1752863348/pages/welcome-package.vue")
  }
]